import React from 'react'
import ConcessionForm from './ConcessionForm'

const ApplyConcessionPage = () => {
  const handleConcessionUpdate = () => {
    // This can be used to trigger refresh if needed
    // For now, we'll keep it simple since we're separating the pages
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-700 via-teal-600/10 to-teal-800 p-6'>
      <div className='max-w-7xl mx-auto'>
        {/* Header */}
        <div className='bg-gray-800 bg-opacity-60 border border-teal-800 rounded-lg shadow-lg p-6 mb-6'>
          <h1 className='text-3xl font-bold text-white mb-2'>
            Apply Concession
          </h1>
          <p className='text-gray-300'>
            Apply a new concession to a customer's booking
          </p>
        </div>

        {/* Form Content */}
        <div className='bg-gray-800 bg-opacity-60 border border-teal-800 rounded-lg shadow-lg overflow-hidden'>
          <ConcessionForm onConcessionUpdate={handleConcessionUpdate} />
        </div>
      </div>
    </div>
  )
}

export default ApplyConcessionPage

